import React, { Component } from 'react';
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';

import ActiveChats from "./ActiveChats";
import PendingChats from "./PendingChats";
import {helperFunctions} from "../../lib/helperFunctions";
import SimpleBarReact from "simplebar-react";
import SupervisedChats from "./SupervisedChats";
import NoChats from "./NoChats";

@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class LeftSidebar extends Component {

    constructor(props) {
        super(props);

        this.state={
            defaultActiveKey:"active"
        }
        this.onSelectTab=this.onSelectTab.bind(this);
        helperFunctions.eventEmitter.addListener('changeLeftTab', (e) => this.changeLeftTab(e));
    }
    onSelectTab(k){
        this.setState({
            defaultActiveKey:k
        })
    }
    changeLeftTab = (e) => {

        this.setState({
            defaultActiveKey:e.tab
        })
    }



    componentDidMount() {
        if(typeof this.props.chatprop.activeChats.filter(chat=>chat.id==this.props.selected_id)!=="undefined"){
            var selectedID=this.props.chatprop.activeChats.filter(chat=>chat.id==this.props.selected_id);
            Object.keys(selectedID).map(key=>{

                if(selectedID[key].status=="P"){

                    this.setState({
                        defaultActiveKey:"queued"
                    })
                } else{
                    this.setState({
                        defaultActiveKey:"active"
                    })
                }

            });

        } else{
            this.setState({
                defaultActiveKey:"active"
            })
        }
    }

    render() {
        const { t } = this.props;



        return (
            <>
                <div className="sidebar-group left-sidebar chat_sidebar">

                    <div id="chats" className="left-sidebar-wrap sidebar active">
                        <div className="sidebar-body" id="chatsidebar">
                            {this.props.chatprop.activeChatsLoaded == true && Object.keys(this.props.chatprop.activeChats).length > 0 &&
                            <SimpleBarReact style={{maxHeight: "100%", height: "auto"}}>
                                <ul className="user-list chat-list">
                                    {typeof this.props.chatprop.activeChats.filter(chat => chat.status == 'A' && chat.supervised != 1) !== "undefined" &&
                                    <React.Fragment>
                                        {Object.keys(this.props.chatprop.activeChats.filter(chat => chat.status == 'A' && chat.supervised != 1)).length > 0 &&

                                        <ActiveChats
                                            chatCount={(typeof this.props.chatprop.activeChats.filter(chat => chat.status == 'A' && chat.supervised != 1) === "undefined" ? 0 : Object.keys(this.props.chatprop.activeChats.filter(chat => chat.status == 'A' && chat.supervised != 1)).length)}
                                            closeChat={this.props.closeChat} selected_id={this.props.selected_id}/>

                                        }
                                    </React.Fragment>
                                    }
                                    {typeof this.props.chatprop.activeChats.filter(chat => chat.status == 'P' & chat.supervised != 1) !== "undefined" &&
                                    <React.Fragment>
                                        {Object.keys(this.props.chatprop.activeChats.filter(chat => chat.status == 'P' & chat.supervised != 1)).length > 0 &&
                                        <PendingChats
                                            chatCount={(typeof this.props.chatprop.activeChats.filter(chat => chat.status == 'P' & chat.supervised != 1) === "undefined" ? 0 : Object.keys(this.props.chatprop.activeChats.filter(chat => chat.status == 'P' & chat.supervised != 1)).length)}
                                            closeChat={this.props.closeChat} selected_id={this.props.selected_id}/>
                                        }
                                    </React.Fragment>
                                    }

                                    {typeof this.props.chatprop.activeChats.filter(chat => chat.supervised === 1) !== "undefined" &&
                                    <React.Fragment>
                                        {Object.keys(this.props.chatprop.activeChats.filter(chat => chat.supervised === 1)).length > 0 &&
                                        <SupervisedChats
                                            chatCount={(typeof this.props.chatprop.activeChats.filter(chat => chat.supervised === 1) === "undefined" ? 0 : Object.keys(this.props.chatprop.activeChats.filter(chat => chat.supervised === 1)).length)}
                                            closeSupervised={this.props.closeSupervised}
                                            selected_id={this.props.selected_id}/>
                                        }
                                    </React.Fragment>
                                    }
                                </ul>
                            </SimpleBarReact>
                            }
                            {this.props.chatprop.activeChatsLoaded == true && Object.keys(this.props.chatprop.activeChats).length <1 &&
                                <NoChats/>
                            }
							{this.props.chatprop.activeChatsLoaded == false &&
				<>
                    <div className="no-chats">
                        <h2>Loading Messages</h2>
                    </div>
                </>
                            }
                        </div>
                    </div>

                </div>

            </>

        )

    }
}

export default withTranslation()(LeftSidebar);
